import { SET_AWAITING_AUTO_SAVE } from './screens/EpisodeEditorScreen/duck';

// constants

const initialState = {
  doHaveUnsavedChanges: false,
};

// reducer

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_AWAITING_AUTO_SAVE: {
      return {
        ...state,
        doHaveUnsavedChanges: !!action.payload.awaitingAutoSave,
      };
    }
    default:
      return state;
  }
}
